import { useContext } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import moment from 'moment'

import { AppContext } from '../../context/AppContext'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import { GiftCardEdit } from '../../constants/forms/GiftCard'
import { EditGiftCard, getSingleGiftCard } from '../../network/GiftCards'

const formatData = (data) => ({
    giftCardID: data.giftCardID,
    grantedByName: data.grantedBy?.name,
    grantedBy: data.grantedBy?.id,
    type: data.type,
    customer: data.customer?.id,
    offeredBy: data.offeredBy?.id,
    amount: data.amount,
    expirationDate: data.expirationDate
        ? moment(data.expirationDate)
        : undefined,
    communities: data.communities?.map((c) => c.id),
    status: data.status,
})

const EditGiftCardPage = () => {
    const { token } = useContext(AppContext)
    const { giftCardId } = useParams()

    const giftCardDetails = useQuery(
        [
            'getSingleGiftCard',
            {
                giftCardId,
                token: token.token,
            },
        ],
        getSingleGiftCard,
        {
            refetchOnWindowFocus: false,
        }
    )

    if (giftCardDetails.data?.status === 'used') {
        return <Redirect to="/gift-cards" />
    }

    return (
        <PageWrap
            goBack
            isLoading={giftCardDetails.isLoading}
            title={giftCardDetails.data?.giftCardID || 'edit_gift_card'}
        >
            {giftCardDetails.isError ? (
                <Error retry={() => giftCardDetails.refetch()} />
            ) : giftCardDetails.isLoading ? (
                <Loader />
            ) : (
                <FormWrap
                    title="edit_gift_card"
                    request={EditGiftCard}
                    id={giftCardId}
                    onSuccess="/gift-cards"
                    onCancel="/gift-cards"
                    data={formatData(giftCardDetails.data)}
                    cleanBeforeSending={(oldData) => {
                        delete oldData.grantedByName
                        if (!oldData.customer) oldData.customer = null
                        if (!oldData.offeredBy) oldData.offeredBy = null
                        return oldData
                    }}
                    invalidate={[
                        'getGiftCards',
                        'getSingleGiftCard',
                        'getCustomerGiftCards',
                    ]}
                >
                    <FormBlock formTemplate={GiftCardEdit} />
                </FormWrap>
            )}
        </PageWrap>
    )
}

export default EditGiftCardPage
